import HttpService from "./http";

export interface VerifyReservationResponse {
  code: string;
  message: string;
  element: {
    success: boolean;
    tickets_registered: number;
    reservation_id: string;
    already_processed?: boolean;
    ticket_details?: unknown;
  };
}

export interface EventTicket {
  ticket_id: string;
  event_code: string;
  ticket_holder_emails: string[];
  timestamp: string;
  status: "active" | "used";
  source: string;
  ticket_quantity: number;
  total_amount: number;
  payment_unique_link?: string;
  attendee_email_validation_status?: Record<string, boolean>;
  attendee_already_has_ticket?: Record<string, boolean>;
  purchaser_already_has_ticket?: boolean;
  current_attendee_has_ticket?: Record<string, boolean>;
  current_purchaser_has_ticket?: boolean;
}

export interface MyTicketsResponse {
  code: string;
  message: string;
  element: {
    tickets: EventTicket[];
    total_tickets: number;
  };
}

export interface ReservationDetailsResponse {
  code: string;
  message: string;
  element: {
    reservation_id: string;
    ticket_id: string;
    event_code: string;
    timestamp: string;
    source: string;
    ticket_quantity: number;
    total_amount: number;
    ticket_holder_emails: string[];
    attendee_email_validation_status: Record<string, boolean>;
    current_attendee_has_ticket: Record<string, boolean>;
    current_purchaser_has_ticket: boolean;
    purchaser_already_has_ticket: boolean;
  };
}

const EventService = {
  verifyReservation: (
    customerIdentification: string,
    entityIdentification: string,
    eventCode: string,
    reservation_id?: string
  ) =>
    HttpService.post<VerifyReservationResponse>(
      `/${customerIdentification}/${entityIdentification}/event/verify-reservation`,
      { event_code: eventCode, reservation_id: reservation_id }
    ),

  cancelReservation: (
    customerIdentification: string,
    entityIdentification: string,
    reservationId: string
  ) =>
    HttpService.post(
      `/${customerIdentification}/${entityIdentification}/event/cancel-reservation`,
      { reservation_id: reservationId }
    ),

  getMyTickets: (
    customerIdentification: string,
    entityIdentification: string,
    eventCode: string
  ) =>
    HttpService.get<MyTicketsResponse>(
      `/${customerIdentification}/${entityIdentification}/event/my-tickets/${eventCode}`
    ),

  getReservationDetails: (
    customerIdentification: string,
    entityIdentification: string,
    reservationId: string
  ) =>
    HttpService.get<ReservationDetailsResponse>(
      `/${customerIdentification}/${entityIdentification}/event/reservation-details/${reservationId}`
    ),
};

export default EventService;
